exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".checkbox{font-family:'Montserrat';display:flex;flex-direction:row;align-items:center;cursor:pointer}.checkbox .checkbox-box{width:2.5em;height:2.5em;border:2px solid #D0D0D0;box-shadow:0px 5px 10px rgba(0,0,0,0.08);border-radius:5px;display:flex;align-items:center;justify-content:center}.checkbox .checkbox-box .checkbox-img{max-height:100%;max-width:100%}.checkbox .checkbox-box .checkbox-img svg{display:block}.checkbox .label{font-size:1.4em;font-family:'Open Sans';font-weight:400}.checkbox.checked .checkbox-box{border-color:#6D1CF0}.checkbox.checked .label{color:#6D1CF0}.checkbox.with-label .checkbox-box{margin-right:1.25rem}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/Checkbox/style.scss
// module id = 1422
// module chunks = 0